import { useEffect, useState } from "react";
import { getType, getColor, plushFilter } from "./prizes.js";

/* Ægte INDFARVNING af plys-renders i stedet for CSS-filter: canvas-blend
   "color" sætter kulør/mætning fra den dæmpede pastel (c.soft) og BEVARER
   pelsens luminans — det ligner gennemfarvet plys, ikke neonlys ovenpå en grå
   bamse (Daniels feedback 13/7; sepia/hue-rotate-kæden samler al farve i
   skygger/kanter). globalCompositeOperation virker fint på iOS — det er kun
   ctx.filter, der fejler dér. Resultatet caches som dataURL pr. (type, farve);
   emoji-fallback (med det gamle filter) hvis billedet mangler. */
const tintCache = new Map();

function tintedPlush(type, c, cb) {
  const key = type + "|" + c.id;
  if (tintCache.has(key)) { cb(tintCache.get(key)); return; }
  const img = new Image();
  img.onload = () => {
    try {
      const cv = document.createElement("canvas");
      cv.width = img.naturalWidth; cv.height = img.naturalHeight;
      const x = cv.getContext("2d");
      x.drawImage(img, 0, 0);
      x.globalCompositeOperation = "color";
      x.fillStyle = c.soft;
      x.fillRect(0, 0, cv.width, cv.height);
      x.globalCompositeOperation = "destination-in";
      x.drawImage(img, 0, 0);
      const url = cv.toDataURL("image/png");
      tintCache.set(key, url);
      cb(url);
    } catch {
      cb(null);
    }
  };
  img.onerror = () => cb(null);
  img.src = "/images/plush/" + type + ".png";
}

/* Farvede Gemini-varianter (public/images/plush/c/<type>_<farve>.png — ægte
   to-tonet design pr. farve, genereret m. gen_plush_gemini.mjs --colors) har
   førsteprioritet; findes varianten ikke (endnu), indfarves den neutrale
   render, og mangler alt, vises emojien. Kendte 404'er huskes pr. session. */
const missingColored = new Set();

export default function PlushImg({ type, color, px, className, style, ...rest }) {
  const ty = getType(type), c = getColor(color);
  const key = c ? type + "|" + c.id : "";
  // 0 = farvet variant, 1 = indfarvet neutral, 2 = emoji
  const [stage, setStage] = useState(() => (missingColored.has(key) ? 1 : 0));
  const [tintUrl, setTintUrl] = useState(() => tintCache.get(key) || null);

  useEffect(() => {
    setStage(missingColored.has(type + "|" + (getColor(color) || {}).id) ? 1 : 0);
    setTintUrl(tintCache.get(type + "|" + (getColor(color) || {}).id) || null);
  }, [type, color]);

  useEffect(() => {
    if (stage !== 1) return;
    const cc = getColor(color);
    if (!getType(type) || !cc) return;
    let alive = true;
    tintedPlush(type, cc, (u) => {
      if (!alive) return;
      if (u) setTintUrl(u); else setStage(2);
    });
    return () => { alive = false; };
  }, [stage, type, color]);

  if (!ty || !c) return null;
  if (stage === 2) {
    return (
      <span className={className} style={{ fontSize: px, lineHeight: 1, filter: plushFilter(c), ...style }} {...rest}>
        {ty.emoji}
      </span>
    );
  }
  const src = stage === 0
    ? "/images/plush/c/" + type + "_" + c.id + ".png"
    : tintUrl || "/images/plush/" + type + ".png";
  return (
    <img
      className={className}
      src={src}
      alt={ty.name}
      draggable={false}
      onError={stage === 0 ? () => { missingColored.add(key); setStage(1); } : undefined}
      style={{ height: px, width: "auto", ...style }}
      {...rest}
    />
  );
}
